import { cn } from '@/lib/cn'
import type { ReactNode } from 'react'

export function Card({
  title,
  children,
  className,
  action,
}: {
  title?: string
  children: ReactNode
  className?: string
  action?: ReactNode
}) {
  return (
    <div className={cn('rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)]', className)}>
      {title && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-[var(--color-border)]">
          <h3 className="text-sm font-medium">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  )
}
